__turbopack_context__.v({
  "smsOptinFormContainer": "SMSOptinForm-module__4JwGla__smsOptinFormContainer",
});
